import { memo } from 'preact/compat'

type Props = {
  text: string
}

const ErrorTooltip = (props: Props) => <div className="wf_reset wf_error_tooltip">{props.text}</div>

export default memo(ErrorTooltip)
